import { queryOptions } from "@tanstack/react-query";
import { type CurrentTools, currentToolsResponseSchema } from "../types";
import { enduserApi } from "./client";

/**
 * The end-user's currently provisioned selection + gateway, so the /eu page can
 * rehydrate its checkboxes and connect panel on reload rather than starting
 * empty (which would otherwise let a save overwrite the saved selection).
 */
export const currentToolsQueryOptions = () =>
  queryOptions<CurrentTools>({
    queryKey: ["enduser", "tools"],
    queryFn: async () => {
      const { data } = await enduserApi.get<unknown>("/me/tools");
      return currentToolsResponseSchema.parse(data);
    },
  });
